<!-- @format -->

<section #alertWrapper class="alerts" [class.alerts--sticky]="!topNavigationVisible">
  @for (alert of alerts; track alert) {
    <div class="single-alert" [ngClass]="['alert-id-' + alert.identifier, getAlertStateClassName(alert)]">
      <ngb-alert [type]="alert.type" (closed)="dismissAlert(alert.identifier)" [dismissible]="!alert.hideDismissibleButton">
        @if (!alert.onClickCallback && !alert.scrollToElement) {
          <p class="alert-text" data-cy="alert-text" [attr.id]="alert.identifier" [attr.role]="alert.role ?? 'alert'">{{
            alert.message
          }}</p>
        }
        @if (alert.onClickCallback || alert.scrollToElement) {
          <button
            type="button"
            class="alert-button"
            (keydown)="handleKeyDown($event)"
            data-cy="alert-button"
            [attr.id]="alert.identifier"
            (keydown.enter)="onClickAlert(alert)"
            (keydown.space)="onClickAlert(alert)"
            (click)="onClickAlert(alert)"
            [attr.tabindex]="[alert.onClickCallback || alert.scrollToElement ? '0' : null]">
            <transloco [content]="alert.message" />
          </button>
        }
      </ngb-alert>
    </div>
  }
</section>
